import React from 'react';
import { useAppSelector, useAppDispatch } from '../hooks';
import { selectUser,login } from "../reducers/userSlice";
import { selectVM,turnOn, revert, changeVMID, changeVMOS, infectVM } from "../reducers/vmSlice";
import { Link } from "@chakra-ui/react";
import {
  Stack,
  Center,
  ButtonGroup,
  Heading,
  Button,
  Box,
  Flex,
  Text,
  useColorModeValue,
  Spacer,
  Image
} from "@chakra-ui/react";
import guacamoleUrl from "../api/guacamole";

export default function VMConnectHandler() {
    const user = useAppSelector(selectUser);
    const vm = useAppSelector(selectVM);
    
    if (vm.turnedOn === true && user.loggedIn === true){  /*  */ 


      return (
        <>
        <Link href={guacamoleUrl}  isExternal >
        <Button
          fontSize={"lg"}
          fontWeight={600}
          color={"white"}
          bg={"green.600"}
        >
          Connect
        </Button>
      </Link>
        </>
    );
      }
    else {
      return (
        <Button
          fontSize={"lg"}
          fontWeight={600}
          color={"white"}
          bg={"gray.500"}
        >
          Connect
        </Button>
      );
    }
    
    
  }

// https://malwarevm.sec04.sec-aau.dk/guacamole/#/client/MjBhZDk3NjYtNjc5Ny00Y2Q2LThlNjktZGFiMjI3ZjlhNTk1OjIyNjk5AGMAZGVmYXVsdA?usermame=guacUser638491&password=qA_-oS-XuH22qUvXswkHYAADFQps8CBPT3P0g87MzpUFVLk
